import {toast} from 'react-toastify';

export function showEventNotification(
  action: 'added' | 'updated' | 'removed',
  objectType: string,
  objectName?: string,
) {
  toast(`${objectName ? `${objectType} ${objectName}` : objectType} has been ${action}.`);
}
